import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const sections = [
  { icon: '📍', title: 'Sur scène & sur la route', desc: 'Concerts, tournées — carte & frise chronologique.', count: '247 témoignages', path: '/scene' },
  { icon: '🤝', title: 'Rencontres & hasards', desc: "L'avoir croisé dans la vraie vie, hors contexte officiel.", count: '134 témoignages', path: '/rencontres' },
  { icon: '✨', title: 'Et si…', desc: "Si j'avais pu le rencontrer, j'aurais voulu…", count: '89 témoignages', path: '/etsi' },
  { icon: '🎨', title: 'Art des fans', desc: 'Peintures, gravures, dessins — hommages artistiques.', count: '48 œuvres', path: '/art' },
  { icon: '📸', title: 'Michael', desc: 'Photos rares, vidéos, arts graphiques, enfants, entourage.', count: 'Photos · Vidéos · Enfants · Entourage →', path: '/michael' },
  { icon: '🎬', title: 'Le documentaire', desc: 'Ce que le monde doit savoir sur lui.', count: '56 voix recueillies', path: '/documentaire' },
];

const citationsDefault = [
  { text: "In a world filled with hate, we must still dare to hope. In a world filled with anger, we must still dare to comfort. In a world filled with despair, we must still dare to dream." },
  { text: "The greatest education in the world is watching the masters at work." },
  { text: "In their innocence, very young children know themselves to be light and love. If we will allow them, they can teach us to see ourselves the same way." },
  { text: "I'm never satisfied with myself, and I hope I never will be. That's why I keep trying." },
  { text: "To live is to be musical, starting with the blood dancing in your veins." },
];

const wrap = { maxWidth: '1100px', margin: '0 auto', padding: '0 40px' };

export default function Home() {
  const [citations, setCitations] = useState(citationsDefault);
  const [citIdx, setCitIdx] = useState(0);
  const [fade, setFade] = useState(true);
  const [stats, setStats] = useState(null);
  const [home, setHome] = useState(null);
  const [poll, setPoll] = useState(null);
  const ecouteAudioRef = useRef(null);
  const [ecouteIdx, setEcouteIdx] = useState(null);
  const toggleEcoute = (url, i) => {
    if (ecouteAudioRef.current) { ecouteAudioRef.current.pause(); ecouteAudioRef.current = null; }
    if (ecouteIdx === i) { setEcouteIdx(null); return; }
    const a = new Audio(url);
    a.onended = () => { setEcouteIdx(null); ecouteAudioRef.current = null; };
    a.play().catch(() => {});
    ecouteAudioRef.current = a;
    setEcouteIdx(i);
  };
  const [chatMsgs, setChatMsgs] = useState([]);
  const [chatText, setChatText] = useState('');
  const chatSockRef = useRef(null);
  const chatBoxRef = useRef(null);
  useEffect(() => {
    let sock;
    import('socket.io-client').then(({ io }) => {
      sock = io('https://turn.lepb.fr:3005', { transports: ['websocket'] });
      chatSockRef.current = sock;
      sock.on('chat-history', (msgs) => setChatMsgs(Array.isArray(msgs) ? msgs : []));
      sock.on('chat-message', (m) => setChatMsgs(prev => [...prev, m].slice(-50)));
    });
    return () => { if (sock) sock.disconnect(); };
  }, []);
  useEffect(() => {
    const box = chatBoxRef.current;
    if (box) box.scrollTop = box.scrollHeight;
  }, [chatMsgs]);
  const sendChat = () => {
    const tk = localStorage.getItem('mjtoken');
    if (!tk) { alert('Connectez-vous pour participer au chat.'); return; }
    const t = chatText.trim();
    if (!t || !chatSockRef.current) return;
    chatSockRef.current.emit('chat-send', { token: tk, text: t });
    setChatText('');
  };
  useEffect(() => {
    fetch('/api/home-content').then(r => r.json()).then(d => setHome(d)).catch(() => {});
  }, []);
  useEffect(() => {
    const tk = localStorage.getItem('mjtoken');
    fetch('/api/polls/active', { headers: tk ? { Authorization: 'Bearer ' + tk } : {} })
      .then(r => r.json()).then(d => setPoll(d)).catch(() => {});
  }, []);
  const votePoll = async (optionId) => {
    const tk = localStorage.getItem('mjtoken');
    if (!tk) { alert('Connectez-vous pour voter.'); return; }
    const res = await fetch('/api/polls/' + poll._id + '/vote', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tk },
      body: JSON.stringify({ optionId })
    });
    if (res.ok) { const d = await res.json(); setPoll(d); }
    else { const e = await res.json().catch(() => ({})); alert(e.error || 'Erreur de vote'); }
  };

  useEffect(() => {
    fetch('/api/testimonials/home-stats').then(r => r.json()).then(d => { if (d && d.sections) setStats(d); }).catch(() => {});
  }, []);

  const PATH_KEY = { '/scene': 'scene', '/rencontres': 'rencontre', '/etsi': 'etsi', '/art': 'art', '/documentaire': 'documentaire' };
  const sectionCount = (sec) => {
    if (sec.path === '/michael') return sec.count;
    if (!stats) return '';
    const k = PATH_KEY[sec.path];
    if (k === 'art') return stats.art + (stats.art > 1 ? ' œuvres' : ' œuvre');
    if (k === 'documentaire') { const n = stats.sections.documentaire || 0; return n + (n > 1 ? ' voix recueillies' : ' voix recueillie'); }
    const n = stats.sections[k] || 0;
    return n + (n > 1 ? ' témoignages' : ' témoignage');
  };

  useEffect(() => {
    fetch('/api/citations').then(r => r.json()).then(data => {
      if (Array.isArray(data) && data.length > 0) setCitations(data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!citations.length) return;
    setCitIdx(i => i % citations.length);
    const t = setInterval(() => {
      setFade(false);
      setTimeout(() => { setCitIdx(i => (i + 1) % citations.length); setFade(true); }, 400);
    }, 6000);
    return () => clearInterval(t);
  }, [citations]);

  const changeCit = (dir) => {
    setFade(false);
    setTimeout(() => { setCitIdx(i => (i + dir + citations.length) % citations.length); setFade(true); }, 300);
  };

  const goLink = (lnk) => {
    if (!lnk) return;
    if (/^https?:\/\//.test(lnk)) window.open(lnk, '_blank', 'noopener');
    else window.location.href = lnk;
  };
  const m = home?.media, inf = home?.info;
  const showMedia = m && m.active !== false && m.url;
  const showInfo = inf && inf.active !== false && (inf.title || inf.text);
  const showPoll = poll && poll.active;
  const uneCols = [showMedia && '1fr', showInfo && '1fr', showPoll && '0.85fr'].filter(Boolean).join(' ');

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0, backgroundImage: 'url(/images/hero.jpg)', backgroundSize: 'cover', backgroundPosition: 'center right', backgroundColor: '#0d0510' }} />
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1, background: 'rgba(10,5,8,0.38)', pointerEvents: 'none' }} />
      <div style={{ position: 'relative', zIndex: 2 }}>

        <div style={{ ...wrap, padding: '52px 40px 40px' }}>
          <p style={{ fontSize: '12px', letterSpacing: '0.18em', color: '#e8c0c0', marginBottom: '12px' }}>— mémoire vivante — 1958 · 2009</p>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '48px', fontWeight: '400', color: '#fff', lineHeight: '1.2', marginBottom: '16px', textShadow: '0 2px 30px rgba(0,0,0,0.5)' }}>
            Michael, vu par ceux<br />qui l'ont <em style={{ color: '#e8a0a0', fontStyle: 'italic' }}>aimé</em>
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', maxWidth: '420px', marginBottom: '28px', lineHeight: '1.8' }}>
            Les témoignages de fans et de proches du monde entier. Parcourez, ressentez, et partagez votre souvenir.
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <Link to="/temoigner"><button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '11px 24px', fontSize: '13px', fontWeight: '500', cursor: 'pointer', boxShadow: '0 4px 20px rgba(139,26,42,0.5)' }}>✦ Témoigner</button></Link>
            <Link to="/documentaire"><button style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(6px)', color: '#fff', border: '1px solid rgba(255,255,255,0.5)', borderRadius: '8px', padding: '11px 24px', fontSize: '13px', cursor: 'pointer' }}>🎬 Documentaire</button></Link>
          </div>
        </div>

        <div style={{ background: 'rgba(139,26,42,0.25)', backdropFilter: 'blur(8px)', borderTop: '1px solid rgba(196,144,144,0.2)', borderBottom: '1px solid rgba(196,144,144,0.2)', padding: '20px 0' }}>
          <div style={{ ...wrap, display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ fontSize: '32px', color: '#e8a0a0', fontFamily: 'Georgia,serif', lineHeight: 1, flexShrink: 0, marginTop: '-8px' }}>"</div>
            <div style={{ flex: 1 }}>
              <p style={{ fontFamily: 'Georgia,serif', fontStyle: 'italic', fontSize: '14px', color: '#fff', lineHeight: '1.7', opacity: fade ? 1 : 0, transition: 'opacity 0.4s' }}>
                {citations[citIdx].text}
              </p>
              <p style={{ fontSize: '12px', color: '#e8a0a0', marginTop: '8px', letterSpacing: '0.1em' }}>— Michael Jackson</p>
            </div>
            <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
              <button onClick={() => changeCit(-1)} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '50%', width: '28px', height: '28px', color: '#fff', fontSize: '14px', cursor: 'pointer' }}>‹</button>
              <button onClick={() => changeCit(1)} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '50%', width: '28px', height: '28px', color: '#fff', fontSize: '14px', cursor: 'pointer' }}>›</button>
            </div>
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          <div style={{ ...wrap, display: 'grid', gridTemplateColumns: 'repeat(4,1fr)' }}>
            {[{ n: stats ? stats.total : '…', l: 'témoignages' }, { n: stats ? stats.countries : '…', l: 'pays représentés' }, { n: stats ? stats.events : '…', l: 'événements cartographiés' }, { n: stats ? stats.docVoices : '…', l: 'voix pour le documentaire' }].map((s, i) => (
              <div key={i} style={{ padding: '18px 12px', textAlign: 'center', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.2)' : 'none' }}>
                <div style={{ fontSize: '26px', fontWeight: '500', color: '#1a1010', fontFamily: 'Georgia,serif' }}>{s.n}</div>
                <div style={{ fontSize: '12px', color: '#4a3030', marginTop: '4px' }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        {(showMedia || showInfo || (poll && poll.active)) && (
        <div style={{ background: 'rgba(255,255,255,0.9)', borderBottom: '1px solid rgba(196,144,144,0.2)', padding: '32px 0' }}>
          <div style={{ ...wrap }}>
            <p style={{ fontSize: '12px', letterSpacing: '0.15em', color: '#8b1a2a', marginBottom: '18px', textAlign: 'center' }}>— À LA UNE</p>
            <div className="home-une-grid" style={{ display: 'grid', gridTemplateColumns: uneCols || '1fr', gap: '20px', alignItems: 'stretch' }}>
              {showMedia && (
                <div onClick={() => goLink(m.link)} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: '12px', overflow: 'hidden', cursor: m.link ? 'pointer' : 'default', display: 'flex', flexDirection: 'column' }}>
                  {m.mediaType === 'video'
                    ? <video src={m.url} controls style={{ width: '100%', maxHeight: '300px', background: '#000', display: 'block' }} />
                    : <img src={m.url} alt={m.title || ''} style={{ width: '100%', maxHeight: '300px', objectFit: 'cover', display: 'block' }} />}
                  {(m.title || m.text || m.audioUrl) && (
                    <div style={{ padding: '16px 18px' }}>
                      {(m.title || m.audioUrl) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                          {m.title && <div style={{ fontFamily: 'Georgia,serif', fontSize: '18px', color: '#1a1010' }}>{m.title}</div>}
                          {m.audioUrl && (
                            <button onClick={(e) => { e.stopPropagation(); const a = new Audio(m.audioUrl); a.play(); }}
                              title="Écouter" style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '50%', width: '34px', height: '34px', cursor: 'pointer', fontSize: '16px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {'\uD83D\uDD0A'}
                            </button>
                          )}
                        </div>
                      )}
                      {m.text && <div style={{ fontSize: '13px', color: '#4a3030', lineHeight: '1.7', whiteSpace: 'pre-wrap' }}>{m.text}</div>}
                      {Array.isArray(m.sounds) && m.sounds.length > 0 && (
                        <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #eaddd8' }}>
                          <div style={{ fontSize: '12px', letterSpacing: '0.12em', color: '#8b1a2a', textAlign: 'center', marginBottom: '12px' }}>ÉCOUTE !! {'\uD83E\uDD70'}</div>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '12px', justifyItems: 'center' }}>
                            {m.sounds.map((sd, i) => (
                              <button key={i} onClick={(e) => { e.stopPropagation(); toggleEcoute(sd.url, i); }}
                                title={sd.name || 'Écouter'}
                                style={{ width: '38px', height: '38px', borderRadius: '50%', background: sd.color || '#8b1a2a', border: ecouteIdx === i ? '2px solid #1a1010' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}>
                                <span style={{ fontSize: '17px', color: '#fff', lineHeight: 1 }}>{ecouteIdx === i ? '\u23F8' : '\uD83D\uDD0A'}</span>
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {showInfo && (
                <div onClick={() => goLink(inf.link)} style={{ background: '#8b1a2a', borderRadius: '12px', padding: '24px 26px', cursor: inf.link ? 'pointer' : 'default', display: 'flex', flexDirection: 'column', justifyContent: 'center', color: '#fff' }}>
                  <div style={{ textAlign: 'center' }}>
                    {inf.imageUrl && <img src={inf.imageUrl} alt="" style={{ maxWidth: '100%', maxHeight: '240px', width: 'auto', height: 'auto', objectFit: 'contain', borderRadius: '12px', border: '2px solid rgba(255,255,255,0.4)', marginBottom: '16px', display: 'inline-block' }} />}
                    {inf.title && <div style={{ fontFamily: 'Georgia,serif', fontSize: '20px', marginBottom: '12px' }}>{inf.title}</div>}
                    {inf.text && <div style={{ fontSize: '14px', lineHeight: '1.8', color: '#f0d8d8', whiteSpace: 'pre-wrap' }}>{inf.text}</div>}
                    {inf.link && <div style={{ fontSize: '13px', color: '#fff', marginTop: '14px', fontWeight: '500' }}>En savoir plus →</div>}
                  </div>
                </div>
              )}
              {showPoll && (
                <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: '12px', padding: '18px', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                  <div style={{ fontSize: '11px', letterSpacing: '0.12em', color: '#8b1a2a', marginBottom: '6px', textAlign: 'center' }}>SONDAGE</div>
                  <div style={{ fontFamily: 'Georgia,serif', fontSize: '15px', color: '#1a1010', marginBottom: '14px', textAlign: 'center', lineHeight: 1.4 }}>{poll.question}</div>
                  {poll.options.map(o => {
                    const pct = poll.total > 0 ? Math.round((o.count / poll.total) * 100) : 0;
                    return (
                      <div key={o._id} onClick={() => votePoll(o._id)}
                        style={{ position: 'relative', border: o.mine ? '1.5px solid #8b1a2a' : '1px solid #dccfc8', borderRadius: '8px', padding: '9px 12px', marginBottom: '8px', cursor: 'pointer', overflow: 'hidden', background: '#fafaf8' }}>
                        <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: pct + '%', background: o.mine ? 'rgba(139,26,42,0.18)' : 'rgba(139,26,42,0.08)', transition: 'width 0.4s' }} />
                        <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontSize: '13px', color: '#1a1010', fontWeight: o.mine ? 700 : 400 }}>{o.mine ? '\u2713 ' : ''}{o.text}</span>
                          <span style={{ fontSize: '12px', color: '#8b1a2a', fontWeight: 700, flexShrink: 0 }}>{pct}%</span>
                        </div>
                      </div>
                    );
                  })}
                  <div style={{ fontSize: '11px', color: '#9a8080', textAlign: 'center', paddingTop: '8px' }}>
                    {poll.total} vote{poll.total !== 1 ? 's' : ''}
                  </div>

                  <div style={{ borderTop: '1px solid #eaddd8', marginTop: '12px', paddingTop: '12px', display: 'flex', flexDirection: 'column', flex: 1, minHeight: '160px' }}>
                    <div style={{ fontSize: '11px', letterSpacing: '0.12em', color: '#8b1a2a', textAlign: 'center', marginBottom: '10px' }}>{'\uD83D\uDCAC'} LIVE CHAT</div>
                    <div ref={chatBoxRef} style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '10px', minHeight: 0 }}>
                      {chatMsgs.length === 0 && <div style={{ fontSize: '12px', color: '#b9a89f', fontStyle: 'italic', textAlign: 'center' }}>Aucun message pour l'instant.</div>}
                      {chatMsgs.map((m, i) => (
                        <div key={i} style={{ fontSize: '13px', lineHeight: 1.4 }}>
                          <span style={{ color: '#8b1a2a', fontWeight: 700 }}>{m.username}</span>{' '}
                          <span style={{ color: '#4a3030', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{m.text}</span>
                        </div>
                      ))}
                    </div>
                    {localStorage.getItem('mjtoken') ? (
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <input value={chatText} onChange={e => setChatText(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendChat()}
                          placeholder="Votre message..." style={{ flex: 1, padding: '8px 12px', border: '1px solid #c49090', borderRadius: '20px', fontSize: '13px', background: '#fafaf8' }} />
                        <button onClick={sendChat} style={{ padding: '8px 14px', borderRadius: '20px', border: 'none', background: '#8b1a2a', color: '#fff', fontSize: '13px', cursor: 'pointer' }}>{'\u2192'}</button>
                      </div>
                    ) : (
                      <div style={{ fontSize: '12px', color: '#9a8080', textAlign: 'center', fontStyle: 'italic' }}>Connectez-vous pour participer.</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        )}

        {false && (
        <div style={{ background: 'rgba(255,255,255,0.22)', backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          <div style={{ ...wrap, display: 'grid', gridTemplateColumns: 'repeat(3,1fr)' }}>
            {sections.map((sec, i) => (
              <Link to={sec.path} key={i} style={{ textDecoration: 'none' }}>
                <div style={{ padding: '22px 18px', borderRight: (i+1)%3 !== 0 ? '1px solid rgba(255,255,255,0.25)' : 'none', borderBottom: i < 3 ? '1px solid rgba(255,255,255,0.2)' : 'none', cursor: 'pointer', transition: 'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <div style={{ fontSize: '20px', marginBottom: '8px' }}>{sec.icon}</div>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1010', marginBottom: '5px' }}>{sec.title}</div>
                  <div style={{ fontSize: '12px', color: '#3a2020', lineHeight: '1.5', marginBottom: '8px' }}>{sec.desc}</div>
                  <div style={{ fontSize: '12px', color: '#8b1a2a', fontWeight: '500' }}>{sectionCount(sec)}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        )}

        <div style={{ background: 'rgba(139,26,42,0.82)', backdropFilter: 'blur(10px)', padding: '28px 0' }}>
          <div style={{ ...wrap, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '24px', flexWrap: 'wrap' }}>
            <div>
              <p style={{ fontSize: '12px', letterSpacing: '0.15em', color: '#e8c0c0', marginBottom: '8px' }}>— PROJET DOCUMENTAIRE</p>
              <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '20px', color: '#fff', marginBottom: '10px' }}>Ce que le monde doit savoir sur lui</h2>
              <p style={{ fontSize: '12px', color: '#e8c0c0', lineHeight: '1.8', maxWidth: '460px' }}>Dans quelques années, je souhaite réaliser un documentaire sur Michael — tel qu'il était vraiment. Pas les tabloïds, pas les procès. Lui.</p>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '10px', padding: '20px 28px', textAlign: 'center', minWidth: '130px' }}>
              <div style={{ fontSize: '32px', color: '#fff', fontFamily: 'Georgia,serif' }}>{stats ? stats.docVoices : '…'}</div>
              <div style={{ fontSize: '12px', color: '#e8c0c0', marginTop: '4px' }}>voix recueillies</div>
              <div style={{ fontSize: '12px', color: '#e8c0c0', marginBottom: '12px' }}>de {stats ? stats.docCountries : '…'} pays</div>
              <Link to="/documentaire"><button style={{ background: '#fff', color: '#8b1a2a', border: 'none', borderRadius: '7px', padding: '8px 18px', fontSize: '12px', fontWeight: '500', cursor: 'pointer', width: '100%' }}>Laisser ma voix</button></Link>
            </div>
          </div>
        </div>



      </div>
    </div>
  );
}
